<template>
  <div>
    Reconcliliation
  </div>
</template>

<script>
export default {
  name: 'Reconcliliation'
};
</script>

<style lang="less" scoped></style>
